import R from "ramda";
import { BOOTSTRAP_CARD_NUMBERS } from "actions/bootstrap-actions";

export const initialState = {
  cardNumbers: []
};

export const cardNumbersReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_CARD_NUMBERS:
      return R.merge(state, { cardNumbers: action.data.cardNumbers });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/js/reducers/card-numbers-reducer.js